import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ArchiveEquipmentInput, LinkEquipmentInput, SearchEquipmentsParams, SearchEquipmentsResult, UpdateEquipmentInput } from '../../../../../../../../core/api/equipments/equipments.type';
import { Equipment } from '../../../../../../../../core/interfaces';
import { ARCHIVE_EQUIPMENT_MUTATION, GET_EQUIPMENT_QUERY, LINK_EQUIPMENT_LINK_MUTATION, SEARCH_EQUIPMENTS_QUERY, SEARCH_EQUIPMENTS_WITH_WARRANTIES_QUERY, UNARCHIVE_EQUIPMENT_MUTATION, UPDATE_EQUIPMENT_MUTATION } from './equipment.query';


@Injectable({
  providedIn: 'root',
})
export class EquipmentsServiceApi {
  public constructor(
    private readonly apollo: Apollo,
  ) {}

  public async get(id: string): Promise<Equipment | undefined> {
    return this.apollo
      .query<{ equipment: Equipment }>({
        query: GET_EQUIPMENT_QUERY,
        variables: { id },
      })
      .toPromise()
      .then((response) => response.data && response.data.equipment);
  }

  public async search(params: SearchEquipmentsParams): Promise<SearchEquipmentsResult> {
    return this.apollo
      .query<{ equipments: SearchEquipmentsResult }>({
        query: SEARCH_EQUIPMENTS_QUERY,
        variables: params,
      })
      .toPromise()
      .then((response) => response.data && response.data.equipments);
  }


  public async searchWithWarranties(params: SearchEquipmentsParams): Promise<SearchEquipmentsResult> {
    return this.apollo
      .query<{ equipments: SearchEquipmentsResult }>({
        query: SEARCH_EQUIPMENTS_WITH_WARRANTIES_QUERY,
        variables: params,
      })
      .toPromise()
      .then((response) => response.data && response.data.equipments);
  }


  public async update(params: UpdateEquipmentInput): Promise<Equipment | undefined> {
    return this.apollo.mutate<{ updateEquipment: Equipment }>({
      mutation: UPDATE_EQUIPMENT_MUTATION,
      variables: { input: params },
    })
      .toPromise()
      .then((response) => response.data && response.data.updateEquipment);
  }

  public async archive(params: ArchiveEquipmentInput): Promise<void> {
    await this.apollo.mutate({
      mutation: ARCHIVE_EQUIPMENT_MUTATION,
      variables: { id: params.id },
    })
      .toPromise();
  }

  public async unarchive(params: ArchiveEquipmentInput): Promise<void> {
    await this.apollo.mutate({
      mutation: UNARCHIVE_EQUIPMENT_MUTATION,
      variables: { id: params.id },
    }).toPromise();
  }

  public async linkEquipment(params: LinkEquipmentInput): Promise<void> {
    await this.apollo.mutate({
      mutation: LINK_EQUIPMENT_LINK_MUTATION,
      variables: { input: params },
    }).toPromise();
  }
}
